import { ColorEnum } from '@/constants/color'
import { ContentMeasuredStyles } from '@/features/ui/components/Dropdown/types'
import { FC, ReactNode, RefObject } from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'
import { Gesture, GestureDetector } from 'react-native-gesture-handler'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface ContentProps {
    children: ReactNode
    visible: boolean
    measuredStyles: ContentMeasuredStyles | undefined
    onLayout: () => void
    style?: StyleProp<ViewStyle>
    ref: RefObject<View | null>
}

const Content: FC<ContentProps> = ({ children, visible, measuredStyles, onLayout, style, ref }) => {
    const isShown = visible && measuredStyles

    const { styles } = useStyles(stylesheet, { invisible: !isShown })

    const tap = Gesture.Tap()

    const pointerEvents = isShown ? 'auto' : 'none'

    return (
        <GestureDetector gesture={tap}>
            <View
                pointerEvents={pointerEvents}
                onLayout={onLayout}
                style={[styles.outerContainer, measuredStyles]}
                ref={ref}
            >
                <View style={[styles.innerContainer, style]}>{children}</View>
            </View>
        </GestureDetector>
    )
}

const stylesheet = createStyleSheet({
    outerContainer: {
        borderRadius: 8,
        borderWidth: 1,
        borderColor: ColorEnum.GRAY_300,
        backgroundColor: ColorEnum.WHITE,
        width: 216,
        position: 'absolute',
        variants: {
            invisible: {
                true: {
                    opacity: 0,
                },
            },
        },
    },
    innerContainer: {
        backgroundColor: ColorEnum.WHITE,
        borderRadius: 8,
    },
})

export default Content
